// delete this during specs.events.ui.DonationText-ABC merge
export const translateDonationAbcKey = (translationKey, experimentValue) => {
    switch (experimentValue) {
        case 'B': {
            return `${translationKey}|abTranslate_1|specs.events.ui.DonationText-ABC`;
        }
        case 'C': {
            return `${translationKey}|abTranslate_2|specs.events.ui.DonationText-ABC`;
        }
        default:
            return translationKey;
    }
};
//# sourceMappingURL=utils.js.map